import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WorkerCompetenceSaveView, useAPI } from '@nexelem/api';

export const useAddWorkerCompetenceMutation = () => {
  const api = useAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: WorkerCompetenceSaveView) =>
      api.postBackWorkersWorkerCompetencesSave({
        workerCompetenceSaveView: data,
      }),
    onSuccess: (_, { workerId }) => queryClient.invalidateQueries({ queryKey: ['worker-competences', workerId] }),
  });
};
